import * as React from "react";
import { useState, useEffect } from "react";
import { useAppSelector } from "../../../../app/hooks";
import PlayIcon from "../../../../assets/icons/Pause.png";
import RenderTable from "../RenderTable";
import AiFeedbackQuestionDescription from "../AiFeedbackQuestionDescription";
import useAiFeedBack from "../useAiFeedback";
import PartWiseListeningQuestions from "../PartWiseListeningQuestions";
import SectionWiseQuestions from "../SectionWiseQuestions";
import AnswersDisplay from "../AnswerDisplay";
import FeedbackMessage from "../FeedbackMessage";
import RenderHtml from "./RenderHtml";

const ListeningAIFeedback = () => {
  const { handleAIFeedback } = useAiFeedBack();
  const [aiFeedback, setAIFeedback] = useState({
    partType: "",
    paragraphTitle: "",
    paragraphContent: "",
    questionId: "",
    questionName: "",
    questionType: "",
    userAnswer: "",
    exactAnswer: "",
    isCorrect: false,
    isSelected: false,
    audio: "",
    table: [],
    isAttempted: true,
  });

  const { listeningAiFeedback: data } = useAppSelector(
    (state) => state.root.listeningResults
  );
  const audioRef = React.useRef<HTMLAudioElement>(null);
  const [isAudio, setIsAudio] = useState(false);

  useEffect(() => {
    if (audioRef.current) {
      const volumeLevel = 10 / 100;
      audioRef.current.volume = volumeLevel;
    }
  }, []);

  useEffect(() => {
    setIsAudio(true);
    return () => {
      setIsAudio(false);
    };
  }, [aiFeedback.audio]);

  return (
    <div className="w-full mx-auto ">
      <div className="mt-5">
        <div className="flex gap-4">
          <div className="border border-gray-300 rounded-md bg-white w-1/3 min-h-[70vh]">
            <SectionWiseQuestions />
            {data["part1"] && (
              <PartWiseListeningQuestions
                part="Part 1"
                partData={data.part1}
                aiFeedback={aiFeedback}
                handleAIFeedback={handleAIFeedback}
                setAIFeedback={setAIFeedback}
              />
            )}

            {data["part2"] && (
              <PartWiseListeningQuestions
                part="Part 2"
                partData={data.part2}
                aiFeedback={aiFeedback}
                handleAIFeedback={handleAIFeedback}
                setAIFeedback={setAIFeedback}
              />
            )}

            {data["part3"] && (
              <PartWiseListeningQuestions
                part="Part 3"
                partData={data.part3}
                aiFeedback={aiFeedback}
                handleAIFeedback={handleAIFeedback}
                setAIFeedback={setAIFeedback}
              />
            )}

            {data["part4"] && (
              <PartWiseListeningQuestions
                part="Part 4"
                partData={data.part4}
                aiFeedback={aiFeedback}
                handleAIFeedback={handleAIFeedback}
                setAIFeedback={setAIFeedback}
              />
            )}
          </div>

          <div className="border border-gray-300 rounded-md bg-white w-8/12">
            <h1 className="bg-[#F8F9FA] p-4 font-avenir border rounded-md rounded-b-none border-b-gray-300 font-medium text-[#292D35] text-lg">
              Analysis
            </h1>
            {!aiFeedback.questionId ? (
              <div className="flex justify-center items-center h-full font-avenir ">
                {" "}
                Please Select the Question to get the feedback
              </div>
            ) : (
              <div className="flex justify-between w-full p-4 text-xs">
                <div className="w-1/2 pr-5">
                  <div className="flex items-center text-sm text-[#737E93] uppercase mb-2 font-semibold font-avenir">
                    <span className="mt-2">
                      Academic Listening {aiFeedback.partType}
                    </span>{" "}
                    <button
                      className="flex ml-4 items-center cursor-pointer "
                      onClick={() => setIsAudio(!isAudio)}
                    >
                      {" "}
                      {isAudio ? (
                        <>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            className="mr-2 text-red-600"
                          >
                            <path
                              d="M14.5791 2.32579C14.4529 2.26433 14.3121 2.23948 14.1726 2.25406C14.033 2.26865 13.9004 2.32208 13.7897 2.40829L7.24219 7.49985H3C2.60218 7.49985 2.22064 7.65788 1.93934 7.93919C1.65804 8.22049 1.5 8.60202 1.5 8.99985V14.9998C1.5 15.3977 1.65804 15.7792 1.93934 16.0605C2.22064 16.3418 2.60218 16.4998 3 16.4998H7.24219L13.7897 21.5914C13.9005 21.6775 14.0332 21.7309 14.1728 21.7453C14.3124 21.7597 14.4533 21.7347 14.5793 21.6731C14.7054 21.6115 14.8117 21.5157 14.8861 21.3967C14.9604 21.2777 14.9999 21.1402 15 20.9998V2.99985C15 2.85934 14.9606 2.72166 14.8861 2.60248C14.8117 2.48331 14.7053 2.38743 14.5791 2.32579ZM3 8.99985H6.75V14.9998H3V8.99985ZM13.5 19.4661L8.25 15.3833V8.61641L13.5 4.5336V19.4661ZM18.5625 9.5211C19.1657 10.2059 19.4986 11.0872 19.4986 11.9998C19.4986 12.9125 19.1657 13.7938 18.5625 14.4786C18.43 14.6242 18.2456 14.7119 18.049 14.7227C17.8524 14.7335 17.6595 14.6666 17.5118 14.5364C17.3642 14.4062 17.2736 14.2231 17.2597 14.0268C17.2458 13.8304 17.3097 13.6364 17.4375 13.4867C17.7992 13.0759 17.9988 12.5473 17.9988 11.9998C17.9988 11.4524 17.7992 10.9238 17.4375 10.513C17.3097 10.3633 17.2458 10.1693 17.2597 9.97293C17.2736 9.77656 17.3642 9.59353 17.5118 9.46333C17.6595 9.33314 17.8524 9.26623 18.049 9.27703C18.2456 9.28784 18.43 9.3755 18.5625 9.5211ZM23.25 11.9998C23.2511 13.845 22.5711 15.6257 21.3403 17.0005C21.2067 17.145 21.0216 17.2313 20.825 17.2406C20.6284 17.2499 20.436 17.1815 20.2893 17.0503C20.1426 16.919 20.0535 16.7353 20.041 16.5388C20.0286 16.3424 20.0939 16.1489 20.2228 16.0002C21.2066 14.9001 21.7505 13.4761 21.7505 12.0003C21.7505 10.5245 21.2066 9.1005 20.2228 8.00047C20.1553 7.9274 20.103 7.84163 20.0689 7.74815C20.0349 7.65466 20.0197 7.55533 20.0245 7.45595C20.0292 7.35657 20.0536 7.25911 20.0963 7.16926C20.1391 7.07942 20.1993 6.99897 20.2734 6.93261C20.3475 6.86625 20.4341 6.81531 20.5281 6.78274C20.6222 6.75018 20.7217 6.73665 20.821 6.74293C20.9203 6.74922 21.0173 6.7752 21.1065 6.81936C21.1957 6.86352 21.2751 6.92498 21.3403 7.00016C22.5714 8.37436 23.2515 10.1549 23.25 11.9998Z"
                              fill="#3C424C"
                            />
                          </svg>
                          <p className="flex items-center lowercase">
                            Audio is playing
                          </p>
                        </>
                      ) : (
                        <img alt="play_icon" src={PlayIcon} />
                      )}
                    </button>
                    {isAudio && (
                      <audio
                        ref={audioRef}
                        autoPlay
                        src={aiFeedback.audio}
                        onEnded={() => setIsAudio(false)}
                      >
                        <track
                          kind="captions"
                          src="captions.vtt"
                          srcLang="en"
                          label="English"
                          default
                        />
                      </audio>
                    )}
                  </div>

                  <AiFeedbackQuestionDescription
                    questionType={aiFeedback.questionType}
                  />
                  <p className={`text-[#292D35] text-sm mb-2`}>
                    <RenderHtml aiFeedback={aiFeedback} />
                  </p>
                  {aiFeedback.questionType !== "Table Completion" ? (
                    <>
                      <AnswersDisplay
                        userAnswer={aiFeedback.userAnswer}
                        exactAnswer={aiFeedback.exactAnswer}
                        isCorrect={aiFeedback.isCorrect}
                        isAttempted={aiFeedback.isAttempted}
                        module={"listening"}
                      />
                      <FeedbackMessage
                        isCorrect={aiFeedback.isCorrect}
                        isAttempted={aiFeedback.isAttempted}
                      />
                    </>
                  ) : (
                    <div>
                      {aiFeedback.table && (
                        <RenderTable aiFeedback={aiFeedback} data={data} />
                      )}
                      <AnswersDisplay
                        userAnswer={aiFeedback.userAnswer}
                        exactAnswer={aiFeedback.exactAnswer}
                        isCorrect={aiFeedback.isCorrect}
                        isAttempted={aiFeedback.isAttempted}
                        module="listening"
                      />
                      <FeedbackMessage
                        isCorrect={aiFeedback.isCorrect}
                        isAttempted={aiFeedback.isAttempted}
                      />
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListeningAIFeedback;
